import { action, makeObservable, observable } from 'mobx'

export class DeleteDialogFeatureStore {
  public isOpen = false
  public id?: string

  constructor() {
    makeObservable(this, {
      isOpen: observable,
      id: observable,
      open: action,
      close: action,
    })
  }

  public open = (id: string) => {
    this.id = id
    this.isOpen = true
  }

  public close = () => {
    this.id = undefined
    this.isOpen = false
  }
}
